export function generateSubsetSchema(
  fullSchema: object,
  selectedFields: string[],
  requiredOverrides: Record<string, boolean>
): object {
  const schemaObj = fullSchema as Record<string, unknown>;
  const allProperties = (schemaObj.properties || {}) as Record<string, unknown>;
  const originalRequired = (schemaObj.required as string[]) || [];

  // Filter to selected properties only
  const properties: Record<string, unknown> = {};
  selectedFields.forEach(field => {
    if (allProperties[field]) {
      properties[field] = allProperties[field];
    }
  });

  // Compute required array based on overrides
  const required = selectedFields.filter(field => {
    if (field in requiredOverrides) {
      return requiredOverrides[field];
    }
    return originalRequired.includes(field);
  });

  const result: Record<string, unknown> = {
    $schema: 'https://json-schema.org/draft/2020-12/schema',
    type: 'object',
    title: (schemaObj.title as string) || 'CustomSchema',
    properties,
  };

  if (required.length > 0) {
    result.required = required;
  }

  if (schemaObj.description) {
    result.description = schemaObj.description;
  }

  return result;
}

export function generateJsonSchemaString(
  fullSchema: object,
  selectedFields: string[],
  requiredOverrides: Record<string, boolean>
): string {
  const schema = generateSubsetSchema(fullSchema, selectedFields, requiredOverrides);
  return JSON.stringify(schema, null, 2);
}
